<div *ngIf="config?.v && !isAppUser" class="download-app-banner" [ngClass]="'theme-'+config?.v">
  <div class="container">
    <div class="desc">
      <div class="title" *ngIf="!config?.v?.toString()?.match('7')">{{config?.title || 'Download Ketto App'}}</div>
      <div *ngIf="config?.v?.toString()?.match('4|5')" class="list">
        <ul><li *ngFor="let item of kettoDescList">{{item.title}}</li></ul>
      </div>
      <div *ngIf="!config?.v?.toString()?.match('4|7')" class="app-btn">
        <ng-container [ngTemplateOutlet]="downloadBtns"></ng-container>
      </div>
      <div *ngIf="config?.v?.toString()?.match('4|7')" class="app-btn">
        <ng-container [ngTemplateOutlet]="downloadDropDown"></ng-container>
      </div>
      <div *ngIf="config?.v?.toString()?.match('1|4')" class="ketto-logo"><img data-src="/assets/images/logo-birdie.svg" alt="brand logo" loading="lazy"></div>
      <div *ngIf="config?.v?.toString()?.match('5')" class="ketto-logo"><img data-src="/assets/images/birdie-icon.png" alt="brand logo" loading="lazy"></div>
      <div *ngIf="config?.v?.toString()?.match('1|4|5')" class="banner-image" data-bg="/assets/images/anniversary/mobile.png?w"></div>
    </div>
  </div>
</div>

<ng-container *ngIf="!config?.v" [ngTemplateOutlet]="isSipSubscribed ? sipAppDownloaadRef: mcdAppDownloadRef"></ng-container>
<ng-template #sipAppDownloaadRef>
  <div class="wrapper-sip-banner">
    <div class="card-box">
      <div class="main-title">
        {{config?.title || 'Manage Monthly Contribution on your fingertips'}}
      </div>
      <div class="content">
        <div class="img-wrapper">
          <img data-src="/assets/images/sip/sip-main-banner-img.png" alt="no image" loading="lazy">
          <div class="main-mob-title d-lg-none d-block">
            {{config?.title || 'Manage monthly contributions'}}
          </div>
        </div>
        <ng-container *ngTemplateOutlet="description; context : { type: 'sip' }"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mcdAppDownloadRef>
  <div class="wrapper-mcd-app">
    <div class="img-wrapper">
      <img data-src="/assets/images/homepage/mcd-app-homepage.png" loading="lazy" alt="mcd image" />
    </div>
    <div class="mcd-card-homepage">
      <div class="title">
        {{config?.title || 'Manage your fundraisers on the go'}}
      </div>
      <ng-container *ngTemplateOutlet="description; context: { type: 'mcd' }"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #description let-type="type">
  <div class="description">
    <div class="grid-wrapper" *ngIf="isLoaded">
      <div class="grid-item" *ngFor="let item of selectedListData; index as i" [ngClass]="{ 'order-2': (isMobile && i % 2 === 1 && isSipSubscribed) }">
        <div class="icon-wrapper">
          <img [attr.data-src]="(type === 'mcd'? 'assets/images/download/' :'assets/images/sip/icons/') + item.iconName + '.png'" alt="no icon image" loading="lazy" />
        </div>
        <div class="text" [ngClass]="{ 'w-90': i === (selectedListData.length - 1) }">
          {{ item.title }}
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="downloadBtns; context: { type: type }"></ng-container>
  </div>
</ng-template>


<ng-template #downloadBtns let-type="type">
  <div class="download-img" *ngIf="!isMobile">
    <div *ngIf="type==='mcd'">
      <a [href]="vars.appLink.android_mcd" target="_blank" (click)="systemEvents('android')">
        <img *ngIf="!config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/icons/black-google-store.png" alt="no image" />
        <img *ngIf="config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/google-download.png" alt="no image">
      </a>
      <a [href]="vars.appLink.iOS_mcd" target="_blank" (click)="systemEvents('iOS')">
        <img *ngIf="!config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/App-Store-black.png" alt="no image" />
        <img *ngIf="config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/App-Store.png" alt="no image">
      </a>
    </div>
    <div *ngIf="type!=='mcd' && !vars.pageName?.match('home|stories|campaign|thank_you')">
      <a [href]="vars.appLink.android" target="_blank" (click)="systemEvents('android')">
        <img *ngIf="!config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/icons/black-google-store.png" alt="no image" />
        <img *ngIf="config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/google-download.png" alt="no image">
      </a>
      <a [href]="vars.appLink.iOS" target="_blank" (click)="systemEvents('iOS')">
        <img *ngIf="!config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/App-Store-black.png" alt="no image" />
        <img *ngIf="config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/App-Store.png" alt="no image">
      </a>
    </div>
    <div *ngIf="type!=='mcd' && vars.pageName?.match('home|stories|campaign|thank_you')">
      <a [href]="vars.appLink.app_flyer_android" target="_blank" (click)="systemEvents('android')">
        <img *ngIf="!config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/icons/black-google-store.png" alt="no image" />
        <img *ngIf="config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/google-download.png" alt="no image">
      </a>
      <a [href]="vars.appLink.app_flyer" target="_blank" (click)="systemEvents('iOS')">
        <img *ngIf="!config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/App-Store-black.png" alt="no image" />
        <img *ngIf="config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/App-Store.png" alt="no image">
      </a>
    </div>
  </div>
  <div class="download-img" *ngIf="isMobile" (click)="downloadAppRedirect(type)">
    <img *ngIf="!config?.v?.toString()?.match('6')" loading="lazy" [attr.data-src]="isIos ? '/assets/images/sip/App-Store-black.png' : '/assets/images/sip/icons/black-google-store.png'" alt="no image" />
    <img *ngIf="config?.v?.toString()?.match('6')" loading="lazy" [attr.data-src]="isIos ? '/assets/images/sip/App-Store.png' : '/assets/images/sip/google-download.png'" alt="no image" />
  </div>
</ng-template>

<ng-template #downloadDropDown>
  <div class="download-btn">
    <a *ngIf="isMobile && !isIos" [href]="vars.pageName?.match('home|stories|campaign') ? vars.appLink.app_flyer_android : vars.appLink.android" target="_blank" (click)="systemEvents('android')">
      <button mat-button>Download Now</button>
    </a>
    <a *ngIf="isMobile && isIos" [href]="vars.pageName?.match('home|stories|campaign') ? vars.appLink.app_flyer : vars.appLink.iOS" target="_blank" (click)="systemEvents('iOS')">
      <button mat-button>Download Now</button>
    </a>
    <mat-chip-list *ngIf="!isMobile">
      <mat-chip [matMenuTriggerFor]="downloadMenu">{{config?.title || 'Download Now'}}</mat-chip>
    </mat-chip-list>
    <mat-menu #downloadMenu="matMenu" class="menu">
      <div><a [href]="vars.pageName?.match('home|stories|campaign') ? vars.appLink.app_flyer_android : vars.appLink.android" target="_blank" (click)="systemEvents('android')"><button class="menu-item" mat-menu-item>Android</button></a></div>
      <div><a [href]="vars.pageName?.match('home|stories|campaign') ? vars.appLink.app_flyer : vars.appLink.iOS" target="_blank" (click)="systemEvents('iOS')"><button class="menu-item" mat-menu-item>iPhone</button></a></div>
    </mat-menu>
  </div>
</ng-template>
